function addDays(date, days) {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export default (shoot, sending) => {
  let shootStatus = shoot.status
  if (
    shootStatus === "cancelled" ||
    shootStatus === "billed" ||
    shootStatus === "paid"
    //  ||
    // shootStatus === "open"
  ) {
    return shootStatus
  }
  const shootDate = new Date(shoot.end_date).getTime(),
    today = new Date(addDays(new Date(), -1)).getTime()

  // open or booked
  if (today > shootDate) {
    if (shoot.firm) {
      shootStatus = "wrapped"
    } else {
      shootStatus = "cancelled"
    }
  } else if (shootDate >= today || shoot.roles.length === 0) {
    if (
      shoot.roles.filter(x => x.user_id && x.requested && x.available)
        .length === shoot.roles.length &&
      shoot.roles.length !== 0
    ) {
      shootStatus = "booked"
    } else {
      shootStatus = "open"
    }
  }
  return shootStatus
}
